<template>
  <DpplTooltip
    :tooltip-offset="12"
  >
    <template #activator="{ onMouseenter, onMouseleave }">
      <div
        :class="['activator', route.name]"
        @mouseenter="onMouseenter"
        @mouseleave="onMouseleave"
      >
        On-Hold
      </div>
    </template>
    <template #tooltip-content>
      <div class="tooltip-content">
        <h5>On-Hold Requisition</h5>
        <p>{{ tooltipText }}</p>
      </div>
    </template>
  </DpplTooltip>
</template>

<script setup>
import { ref } from 'vue';
import { useRoute } from 'vue-router';
import DpplTooltip from '@/components/datapeople/DpplTooltip.vue';
import { reqOnHoldTooltipText } from '@/helpers/tooltips';

const route = useRoute();

const tooltipText = ref(reqOnHoldTooltipText);
</script>

<style lang="less" scoped>
.activator {
  font-size: 12px;
  font-weight: 500;
  height: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 24px;
  padding: 0 6px;
  width: max-content;

  &.draft-requisitions {
    background-color: @navy-500;
    color: @white;
  }

  &.open-requisitions {
    background-color: @basic-yellow;
    color: @white;
  }

  &.closed-requisitions {
    background-color: @white;
    color: @basic-yellow;
    border: 1px solid @stroke-default;
  }
}

.tooltip-content {
  h5 {
    font-size: 14px;
    font-weight: 500;
    color: @text-darkest;
  }

  p {
    font-size: 13px;
    font-weight: 500;
    color: @text-light;
  }
}
</style>
